import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppCode } from './components/routes/appcode/app-code.jsx';
import { Login } from './components/routes/login/login.jsx';
import { People } from './components/routes/people/people.jsx';
import { Program } from './components/routes/program/program.jsx';
import { Header } from 'app/components/shared/header/header';
import { Message } from 'app/components/routes/message/message';
import { Review } from 'app/components/routes/review/review';
import { Spinner } from 'app/components/shared/spinner/spinner';
import recognitionService from 'app/services/recognition';

export const AppRouting = ( props ) => {
    const [ route, setRoute ] = useState( '' );
    const [ forward, setForward ] = useState( false );
    
    const loading = useSelector( state => state.app.loading );
    const appLoaded = useSelector( state => state.app.appLoaded );
        
    const updatedRoute = window.location.pathname !== '/index.html' ? 'login' : route;
    const appCode = localStorage.getItem( 'appcode' );
    let user = localStorage.getItem( 'user' );

    const handleSetRoute = ( stepName, forward ) => {
        setRoute( stepName );
        setForward( forward );
    };

    useEffect( () => {
        if ( user && appCode ) {
            setRoute( 'people' );
            // refreshing recognition sdk after user logged in to make sure we have complete info like companyId and token to call different services
            recognitionService.recognitionServiceRefresh();
        } else {
            setRoute( 'appcode' );
        }
    }, [ appCode, user ] );
    
    return (
        <div>
            <Spinner loading={ ( loading || !appLoaded ) } />
            { appLoaded &&
                <>
                    { appCode && user && <Header changeRoute={ handleSetRoute }/> }
                    { ( () => {
                        switch ( updatedRoute ) {
                            case 'appcode':
                                return <AppCode changeRoute={ setRoute } forward={ forward }/>;
                            case 'login':
                                return <Login changeRoute={ setRoute } forward={ forward }/>;
                            case 'people':
                                return <People changeRoute={ setRoute } forward={ forward }/>;
                            case 'program':
                                return <Program changeRoute={ setRoute } forward={ forward }/>;
                            case 'message':
                                return <Message changeRoute={ setRoute } forward={ forward }/>;
                            case 'review':
                                return <Review changeRoute={ setRoute } forward={ forward }/>;
                            default:
                                return <div/>;
                        }
                    } )() }
                </>
            }
        </div>
    );
};